import { supabase } from '../lib/supabase';
import { logError } from '../lib/logError';

/**
 * Cliente das rotas de provisionamento de usuário (api/criar-usuario.js e api/ghl-usuarios.js).
 *
 * A criação NÃO passa pelo cliente Supabase do navegador de propósito: exige service role
 * (Admin API do Auth) e o token do GHL, que não podem viver no bundle — vão nas rotas server-side.
 * O antigo `supabaseAdmin` foi removido em 2026-08-05 (ver lib/supabase.js): era código morto e
 * um caminho para a service_role acabar no bundle.
 */

/** Usuários do GHL disponíveis para vínculo, já marcando quem está em uso. */
export async function listarUsuariosGhl() {
    const res = await fetch('/api/ghl-usuarios');
    if (!res.ok) {
        const e = new Error('Não consegui listar os usuários do GHL.');
        await logError(e, { fn: 'listarUsuariosGhl', status: res.status });
        throw e;
    }
    const { usuarios } = await res.json();
    return usuarios ?? [];
}

/**
 * Cria a entidade usuário inteira. Devolve { ok, pessoa, avisos } — `avisos` traz o que
 * ficou pela metade (ex.: GHL fora do ar) sem que a criação toda tenha falhado.
 */
export async function criarUsuario(dados) {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) throw new Error('Sessão expirada. Entre novamente.');

    const res = await fetch('/api/criar-usuario', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(dados),
    });

    const corpo = await res.json().catch(() => ({}));
    if (!res.ok) {
        const e = new Error(corpo?.error || 'Falha ao criar usuário.');
        await logError(e, { fn: 'criarUsuario', status: res.status });
        throw e;
    }
    return corpo;
}
